import { render, staticRenderFns } from "./HeartOutline.vue?vue&type=template&id=63cca4f5&"
import script from "./HeartOutline.vue?vue&type=script&lang=ts&"
export * from "./HeartOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports